/* eslint-disable */
import {
	AddParamTagName,
	AdditionalColumns,
	AddParamChecklistQuestionLocal,
	AdditionalRows,
	ReportParametersType,
	ViewOptionsRowsOrColumns,
	AddParamChecklistLocal,
	ViewOptionsRowsOrColumnsResponse,
	RowsGroupByParametersTypeResponse,
} from 'store/reports/reports.types';
import { CriteriasType } from 'store/search/search.types';
import { convertCriteriasForRequest } from 'utils/convertDataForSearchFilters/convertData';
import { criteriaWithComplexValues } from 'configs/searchCriteria';

// TODO: необходим рефакторинг
// TODO: необходима типизация

export const convertAdditionalParams = (data: ViewOptionsRowsOrColumns): ViewOptionsRowsOrColumnsResponse => {
	let convertedAdditionalParams: ViewOptionsRowsOrColumnsResponse['additional_params'] = [];
	let param = data.additional_params;
	param.forEach((paramItem: AddParamTagName | AddParamChecklistQuestionLocal | AddParamChecklistLocal) => {
		if ('tag_name' in paramItem) {
			convertedAdditionalParams.push(paramItem as AddParamTagName);
		} else if ('isWithQuestion' in paramItem) {
			let values = paramItem.checklists.map((checklist) => {
				const convertedValues = JSON.parse(checklist.value);
				const { checklist_id, question_id } = convertedValues;
				return {
					checklist_id,
					question_id,
				};
			});
			convertedAdditionalParams.push(...values);
		} else if ('checklists' in paramItem) {
			let values = paramItem.checklists.map((checklist) => {
				const convertedValues = JSON.parse(checklist.value);
				const { checklist_id } = convertedValues;
				return {
					checklist_id,
				};
			});
			convertedAdditionalParams.push(...values);
		} else {
			convertedAdditionalParams.push(paramItem);
		}
	});

	return { ...data, additional_params: convertedAdditionalParams };
};

export const convertDefaultRow = (activeReport: any) => {
	let defaultRow = activeReport.rows_group_by[0];
	let copyDefaultRow = { ...defaultRow };

	if (defaultRow.group_by === 'tag_name_value') {
		const values = [];

		for (let i = 0; i < defaultRow.value.values.length; i++) {
			const item = defaultRow.value.values[i];
			if (item.value) values.push(item.value);
			else values.push(item);
		}
		copyDefaultRow = {
			...defaultRow,
			value: {
				...defaultRow.value,
				values,
			},
		};
	}
	const view_options = convertAdditionalParams(defaultRow.view_options);

	return { ...activeReport, rows_group_by: [{ ...copyDefaultRow, view_options }] };
};

export const convertDefaultColumn = (activeReport: any, searchItems: any) => {
	const colsGroupByDefault = activeReport.cols_group_by[0];
	const colsGroupByGroup = colsGroupByDefault.group_by;
	let convertedColsGroupBy = {};

	switch (colsGroupByGroup) {
		case 'search_items':
			const value = {
				...colsGroupByDefault.value,
				search_items: searchItems,
			};
			convertedColsGroupBy = {
				group_by: colsGroupByGroup,
				value,
				view_options: convertAdditionalParams(colsGroupByDefault.view_options),
			};
			break;

		case 'tag_name_value':
			let values = colsGroupByDefault.value.values.map((valueItem: any) => {
				if (valueItem.value) return valueItem.value;
				else return valueItem;
			});
			convertedColsGroupBy = {
				group_by: colsGroupByGroup,
				value: {
					...colsGroupByDefault.value,
					values,
				},
				view_options: convertAdditionalParams(colsGroupByDefault.view_options),
			};
			break;

		case 'tag_name_list':
			let valuesList = colsGroupByDefault.value.values.map((valueItem: any) => {
				if (valueItem.value) return valueItem.value;
				else return valueItem;
			});
			convertedColsGroupBy = {
				group_by: colsGroupByGroup,
				value: {
					...colsGroupByDefault.value,
					values: valuesList,
				},
				view_options: convertAdditionalParams(colsGroupByDefault.view_options),
			};
			break;

		default:
			convertedColsGroupBy = {
				group_by: colsGroupByGroup,
				view_options: convertAdditionalParams(colsGroupByDefault.view_options),
			};
			break;
	}
	return { ...activeReport, cols_group_by: [convertedColsGroupBy] };
};

// позже в задаче
export const convertAdditionalColsGroupBy = (obj: any, parameters: any): ReportParametersType | undefined => {
	const activeReport = { ...obj };
	const local: any = [];
	for (let i = 0; i < parameters.length; i++) {
		if (!parameters[i][0].select.value) {
			return;
		}
		if (parameters[i][0].select.value.value === 'tag') {
			local.push({
				group_by: parameters[i][0].select.value.value,
				value: parameters[i][0].tagsVal.value.value,
				view_options: convertAdditionalParams(parameters[i][0].viewOptions),
			});
		} else if (parameters[i][0].select.value.value === 'search_items') {
			const searchItemsArr = [];
			const activeValues = parameters[i][0].callFilters.activeValues;
			for (let y = 0; y < activeValues.length; y++) {
				const newSearchItems = criteriaWithComplexValues.includes(activeValues[y].key)
					? {
							key: activeValues[y].key,
							complexValues: activeValues[y].values.map((value: string) => JSON.parse(value)),
							logic: activeValues[y].logic || 'and',
					  }
					: {
							key: activeValues[y].key,
							values: activeValues[y].values,
					  };
				searchItemsArr.push(newSearchItems);
			}
			local.push({
				group_by: parameters[i][0].select.value.value,
				value: {
					col_name: parameters[i][0].nameColumn.value,
					search_items: searchItemsArr,
				},
				view_options: convertAdditionalParams(parameters[i][0].viewOptions),
			});
		} else if (parameters[i][0].select.value.value === 'tag_name_list') {
			const tagsNameList = parameters[i][0].tagsNameList;
			const localValues = [];
			for (let i = 0; i < tagsNameList.values.length; i++) {
				localValues.push(tagsNameList.values[i].value);
			}
			local.push({
				group_by: parameters[i][0].select.value.value,
				value: {
					values: localValues,
					col_name: tagsNameList.col_name,
					split: tagsNameList.split,
				},
				view_options: convertAdditionalParams(parameters[i][0].viewOptions),
			});
		} else if (parameters[i][0].select.value.value === 'tag_name_value') {
			const tagNameValue = parameters[i][0].tagNameValue;
			const localValues = [];
			for (let i = 0; i < tagNameValue.values.length; i++) {
				localValues.push(tagNameValue.values[i].value);
			}
			local.push({
				group_by: parameters[i][0].select.value.value,
				value: {
					name: tagNameValue.name,
					values: localValues,
					split: tagNameValue.split,
				},
				view_options: convertAdditionalParams(parameters[i][0].viewOptions),
			});
		} else {
			local.push({
				group_by: parameters[i][0].select.value.value,
				view_options: convertAdditionalParams(parameters[i][0].viewOptions),
			});
		}
	}
	const colGroup = activeReport.cols_group_by[0];
	const localArr = [...[colGroup], ...local];
	activeReport.cols_group_by = localArr;
	return activeReport;
};

export const convertCallSearch = (callSearchArr: any, requestBody: any) => ({
	...requestBody,
	call_search_items: callSearchArr,
});

export const joinReportIdWithBodyReport = (requestBody: any, reportId: string | undefined) => {
	if (reportId) {
		return { ...requestBody, report_id: reportId };
	}
	return requestBody;
};

export const convertAdditionalRows = (
	additionalRows: AdditionalRows[],
	data: ReportParametersType,
): RowsGroupByParametersTypeResponse[] => {
	let convertedRows: RowsGroupByParametersTypeResponse[] = additionalRows.map((row) => {
		let groupByRow = row.groupByRowsValue.value;
		let groupingValue: any;
		let convertedValue;

		switch (groupByRow) {
			case 'time':
				groupingValue = row.timeRowsReportValue.value;
				break;
			case 'tag_name_value':
				groupingValue = {
					name: row.tagNameValueRow.value,
					values: row.tagNameRowListWithValue.map((listValue) => listValue.value),
					split: row.checkboxSplitRow,
				};
				break;
			default:
				groupingValue = null;
				break;
		}
		return (convertedValue = {
			group_by: groupByRow,
			value: groupingValue,
			// view options для доп строк повторяют дефолтную первую строку, поэтому передаем одинаковые данные
			view_options: convertAdditionalParams(data.rows_group_by[0].view_options),
		});
	});
	return convertedRows;
};

export const joinRows = (activeReport: ReportParametersType, additionalRows: RowsGroupByParametersTypeResponse[]) => {
	return {
		...activeReport,
		rows_group_by: [activeReport.rows_group_by[0], ...additionalRows],
	};
};

export const requestHandler = (
	activeCriterias: CriteriasType[],
	activeCriteriasColumn: CriteriasType[],
	activeReport: ReportParametersType,
	additionalColumns: AdditionalColumns[][],
	additionalRows: AdditionalRows[],
	reportId?: string | undefined,
) => {
	let requestData = [];
	const requestActiveCriterias = convertCriteriasForRequest(activeCriterias);
	const requestSearchItemsColumn = convertCriteriasForRequest(activeCriteriasColumn);

	const requestFilters = convertDefaultColumn(activeReport, requestSearchItemsColumn);
	const requestParams = convertDefaultRow(requestFilters);

	const requestColsGroupBy = convertAdditionalColsGroupBy(requestParams, additionalColumns);
	const requestDataWithCallSearch = convertCallSearch([...requestActiveCriterias], requestColsGroupBy);

	const convertedAdditionalRows = convertAdditionalRows(additionalRows, requestDataWithCallSearch);
	const requestWithAdditionalRows = joinRows(requestDataWithCallSearch, convertedAdditionalRows);
	requestData = joinReportIdWithBodyReport(requestWithAdditionalRows, reportId);

	return requestData;
};
